<style scoped>
.animation-root {
    position: fixed;
    height: 100vh;
    width: 100%;
    top: 0;
    left: 0;
    overflow: hidden;
    z-index: 1000;
    pointer-events: none;
}

.animation-root > .img-container {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    @apply max-w-4xl max-h-full w-full mx-auto;
}

@keyframes scale-in {
    0% {
        transform: scale(0);
    }
    100% {
        transform: scale(1);
    }
}
</style>

<template>
    <div class="animation-root" v-if="show">
        <div class="img-container">
            <img :src="currentFrame.img" :style="currentFrame.style" />
        </div>
    </div>
</template>

<script>
import img1 from '@/assets/img/order_success_animation_frame_1.png';
import img2 from '@/assets/img/order_success_animation_frame_2.png';
import img3 from '@/assets/img/order_success_animation_frame_3.png';

export default {
    components: {},
    props: {
        frameDuration: { type: Number, default: 1.0 } // in second
    },
    data() {
        return {
            currentIndex: 0,
            currentFrame: {},
            show: false,
            frames: [
                {
                    img: img1,
                    style: `animation: scale-in ${this.frameDuration}s`
                },
                { img: img2, style: '' },
                { img: img3, style: '' }
            ]
        };
    },
    mounted() {
        this.updateFrameInterval = setInterval(() => {
            this.next();
        }, this.frameDuration * 1000);
    },
    beforeDestroy() {
        if (this.updateFrameInterval) clearInterval(this.updateFrameInterval);
    },
    methods: {
        next() {
            if (this.currentIndex >= this.frames.length) {
                clearInterval(this.updateFrameInterval);
                this.show = false;
                this.$emit('animationEnded');
            } else {
                this.currentFrame = this.frames[this.currentIndex];
                this.show = true;
                this.currentIndex++;
            }
        }
    }
};
</script>
